export { default, type SnapCarouselHandle } from "./SnapCarousel";
